export default __webpack_public_path__ + "static/media/vscode.b2483a1c.png";